<template>
  <div>
    <v-layout row wrap v-if="clients.length > 0">
      <v-flex xs6 style="height:480px">
        <v-list style="height:100%; overflow-y: auto; border-right: 1px solid gray">
          <v-list-tile @click="selectAllDivisions">
            <v-checkbox readonly v-model="areAllDivisionsSelected"></v-checkbox>
            <v-list-tile-title class="bold"> Select all Client Divisions</v-list-tile-title>
          </v-list-tile>

          <v-list-tile
            v-for="client in clients"
            :key="client.clientId"
            @click="clientId = client.clientId"
            :value="clientId == client.clientId"
            active-class="highlighted"
          >
            <v-list-tile-content>
              <v-list-tile-title v-text="client.clientName"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-flex>
      <v-flex xs6>
        <v-list style="height: 100%; overflow-y: auto;">
          <v-list-tile @click="selectAll(clientId)">
            <v-checkbox readonly v-model="allDivisionsSelectedByClient"></v-checkbox>
            <v-list-tile-title class="bold">Select all Divisions</v-list-tile-title>
          </v-list-tile>

          <v-list-tile
            v-for="division in clientDivisions"
            :key="division.divisionId"
            active-class="highlighted"
            @click="changeSelection(division.divisionId)"
          >
            <v-checkbox v-model="division.selected" :key="division.divisionId"> </v-checkbox>
            <v-list-tile-title v-text="division.divisionName"></v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
    <v-layout v-else row wrap>
      <v-flex xs12>
        <v-card style="height:480px">
          <v-card-text>
            <h2>Please select at least one client in the Info section.</h2>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  watch: {
    clients(newValue) {
      if (newValue.length > 0) {
        this.clientId = newValue[0].clientId
      }
    },
  },
  data() {
    return {
      clientId: null,
    }
  },
  methods: {
    changeSelection(divisionId) {
      const exists = this.value.includes(divisionId)
      const result = exists
        ? this.value.filter(divId => divId != divisionId)
        : [...this.value, divisionId]

      this.$emit('input', result)
    },
    selectAll(clientId) {
      const clientDivisions = this.clientDivisions
        .filter(cd => cd.clientId == clientId)
        .map(cd => cd.divisionId)

      if (this.allDivisionsSelectedByClient) {
        const result = this.value.filter(d => !clientDivisions.includes(d))
        this.$emit('input', result)
        return
      }

      const result = [...this.value, ...clientDivisions]
      this.$emit('input', [...new Set(result)])
    },
    selectAllDivisions() {
      if (this.areAllDivisionsSelected) {
        this.$emit('input', [])
      } else {
        this.$emit('input', this.divisions.map(cd => cd.divisionId))
      }
    },
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    clients: {
      type: Array,
      required: true,
    },
    divisions: {
      type: Array,
      required: true,
    },
  },
  computed: {
    clientDivisions() {
      return this.divisions
        .filter(c => this.clientId == c.clientId)
        .map(d => ({...d, selected: this.value.includes(d.divisionId)}))
    },
    allDivisionsSelectedByClient() {
      if (!this.value) return
      const clientDivisions = this.clientDivisions
        .filter(cd => cd.clientId == this.clientId)
        .map(cd => cd.divisionId)

      return clientDivisions.every(d => this.value.includes(d))
    },
    areAllDivisionsSelected() {
      return this.divisions.length == this.value.length
    },
  },
}
</script>
<style>
.highlighted {
  font-weight: bold;
  background-color: lightgray;
}
.bold {
  font-weight: bold;
}
</style>
